/** LeftNav constants */ export const LeftNavMaxWidth = "290px";
export const LeftNavMinWidth = "38px";
